import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Dropdown } from "antd";
import { ItemType } from "antd/es/menu/interface";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React, { useEffect } from "react";
import { MediaInput } from "../../../../../../_shared";
import { Media } from "../../../../../../js/parsegenerated";

type Props = {
  onChange?: (values: string[]) => void;
  value?: string[];
};

export const MediaInputIcon = observer((props: Props) => {
  const t = useTranslation();
  const [currentValue, setCurrentValue] = React.useState<Media[]>([]);
  const [open, setOpen] = React.useState(false);

  async function handleMediaChange(media: Media[]) {
    const savedMedia = await Media.saveAll(media);
    const removedMedia = currentValue.filter(
      (m) => !savedMedia.some((sm) => sm.id === m.id)
    );
    setCurrentValue(savedMedia);
    Media.destroyAll(removedMedia);
  }

  async function handleCurrentValueChange() {
    if (currentValue.every((m) => props.value?.includes(m.id))) return;
    props.onChange?.(currentValue.map((media) => media.id));
  }

  async function handlePropsValueChange() {
    if (props.value) {
      const notFoundMedia = props.value.filter(
        (id) => !currentValue.some((media) => media.id === id)
      );

      if (notFoundMedia.length === 0) return;

      const media = await new Parse.Query(Media)
        .containedIn("objectId", notFoundMedia)
        .find();
      setCurrentValue((prev) => [...prev, ...media]);
    }
  }

  useEffect(() => {
    handleCurrentValueChange();
  }, [currentValue, props.onChange]);

  useEffect(() => {
    handlePropsValueChange();
  }, [props.value]);

  const items: ItemType[] = [
    {
      key: "media",
      label: (
        <MediaInput
          value={currentValue}
          onChange={(media) => handleMediaChange(media)}
        />
      ),
    },
    {
      key: "close",
      label: (
        <Button
          onClick={() => setOpen(false)}
          style={{ width: "100%" }}
          variant="text"
        >
          {t("maintenance:global.button.close_label")}
        </Button>
      ),
    },
  ];
  return (
    <Dropdown
      open={open}
      menu={{
        items: items,
      }}
    >
      <Button
        size="small"
        icon={<Icon icon="fa:file" />}
        onClick={() => setOpen((prev) => !prev)}
      >
        {t("maintenance:administration.ticket.create.form.media.title")}
      </Button>
    </Dropdown>
  );
});
